import { render, staticRenderFns } from "./OrdersLayout.vue?vue&type=template&id=c8277a8a&"
import script from "./OrdersLayout.vue?vue&type=script&lang=js&"
export * from "./OrdersLayout.vue?vue&type=script&lang=js&"
import style0 from "./OrdersLayout.vue?vue&type=style&index=0&id=c8277a8a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports